/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyermotifonsite3Inputs */

const en_checkinflyermotifonsite3 = /** @type {(inputs: Checkinflyermotifonsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On site`)
};

const de_checkinflyermotifonsite3 = /** @type {(inputs: Checkinflyermotifonsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor Ort`)
};

/**
* | output |
* | --- |
* | "On site" |
*
* @param {Checkinflyermotifonsite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyermotifonsite3 = /** @type {((inputs?: Checkinflyermotifonsite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyermotifonsite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyermotifonsite3(inputs)
	return de_checkinflyermotifonsite3(inputs)
});
export { checkinflyermotifonsite3 as "checkinFlyerMotifOnsite" }